"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotelTariffCard = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _HotelTariffCardDesktop = require("./HotelTariffCardDesktop");
var _HotelTariffCardMobile = require("./HotelTariffCardMobile");
var _excluded = ["isMobile"];
var HotelTariffCard = exports.HotelTariffCard = function HotelTariffCard(_ref) {
  var isMobile = _ref.isMobile,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return isMobile ? /*#__PURE__*/_react["default"].createElement(_HotelTariffCardMobile.HotelTariffCardMobile, props) : /*#__PURE__*/_react["default"].createElement(_HotelTariffCardDesktop.HotelTariffCardDesktop, props);
};